<app-header></app-header>

<!-- <link
  href="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"
  rel="stylesheet"
  id="bootstrap-css"
/>
<script src="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/js/bootstrap.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script> -->
<!------ Include the above in your HEAD tag ---------->
<div class="container-xxl">

  <section class="banner d-flex justify-content-center align-items-center text-center">
    <div class="content" data-aos="zoom-in" data-aos-duration="2000">
      <div class="title">
        <span>المجموعات</span>
      </div>
    
      <div class="links">
        <a class="text-decoration-none" routerLink="/home"> الرئيسية </a>
        <span> / </span>
        <a class="text-decoration-none" routerLink="/"> القسم </a> 
        <span> / </span>
        <a class="text-decoration-none" routerLink="/"> الدورة التدريبية </a>        
        <span> / </span>
        <a class="text-decoration-none" routerLink="/">المجموعات</a>
        <span>/ {{ clas.Number }}</span>
      </div>
    </div>
  </section>


  <div class="container">
    <form method="post">
      <div class="content" data-aos="fade-left" data-aos-duration="2000">                    
              <div class="row">
                <div class="col-md-6">
                  <label>اسم المجموعة</label>
                </div>
                <div class="text col-md-6">
                  <p>{{ clas.Number }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label>اقل سن للطلاب</label>
                </div>
                <div class="text col-md-6">
                  <p>{{ clas.StudentsMinAge }}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <label>اكبر سن للطلاب</label>
                </div>
                <div class="text col-md-6">
                  <p>{{ clas.StudentsMaxAge }}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <label>النوع</label>
                </div>
                <div class="text col-md-6">
                  <p>{{ clas.StudentGender }}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <label>كلمة سر لرابط المجموعة</label>
                </div>
                <div class="text col-md-6">
                  <p>{{ clas.ClassLinkPassword }}</p>
                </div>
                </div>              

              <div class="row">
                <div class="col-md-6">
                  <label>تاريخ البداية</label>
                </div>
                <div class="text col-md-6">
                  <p>{{ clas.StartDate | date:'shortDate' }}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <label>تاريخ النهاية</label>
                </div>
                <div class="text col-md-6">
                  <p>{{ clas.EndDate | date:'shortDate' }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label>المعلم </label>
                </div>
                <div class="text col-md-6">
                  <p class="text-primary" style="cursor: pointer "routerLink="/profile/{{clas.TeacherId}}">{{teacher.userName}}</p>
                </div>
              </div>

              <div class="row">
               <a class="btn btn-warning" href={{clas.ClassLink}}>ادخل إلى مجموعتك الآن</a>
              </div>            
      </div>
    </form>
  
    <div class="session" data-aos="fade-right" data-aos-duration="2000">
      <h2> <i style="color: #757575;" class="fas fa-desktop"></i>&nbsp; الحلقــــــــات</h2>
      <table class="table table-bordered table-hover mt-5 mb-5">
        <thead class="thead-dark">
          <tr>
            <th>رقـــم الحلقة</th>
            <th>بداية الحلقة</th>
            <th>نهايـــة الحلقة</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let classSession of classSessions; let i = index">
         
            <td>{{ classSession.sessionNumber }}</td>
            <td>{{ classSession.startTime|date:'short' }}</td>
            <td>{{ classSession.endTime|date:'short' }}</td>
          </tr>
        </tbody>
      </table>
  
    </div>
  </div>
</div>

<app-footer></app-footer>